module.exports = __webpack_public_path__ + "img/1587793086.512bf0cc.jpg";